export default __webpack_public_path__ + "static/signal-status-db1373d668e1e6456c19a7d8abafedc8.png";